/**
 * WPN GATEWAY ENTERPRISE WEB ADMIN API' dev
 *
 * API version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { CoreApiClientService } from 'pn-core-code';

import { apiBaseUrl } from '../api-base-url';
import { ChangePasswordRequestDto } from '../model/changePasswordRequestDto';
import { UserDropdownResponseDto } from '../model/userDropdownResponseDto';
import { UserPaginationResponseDto } from '../model/userPaginationResponseDto';
import { UserRequestDto } from '../model/userRequestDto';
import { UserResponseDto } from '../model/userResponseDto';
import { ValidationError } from '../model/validationError';

export enum usersDropdownGetUserGroupEnum {
  executive_wpn = 'executive_wpn',
  central_staff_wpn = 'central_staff_wpn',
  branch_staff_wpn = 'branch_staff_wpn',
  branch_executive_franchise = 'branch_executive_franchise',
  branch_staff_franchise = 'branch_staff_franchise',
}
export enum usersGetUserGroupEnum {
  executive_wpn = 'executive_wpn',
  central_staff_wpn = 'central_staff_wpn',
  branch_staff_wpn = 'branch_staff_wpn',
  branch_executive_franchise = 'branch_executive_franchise',
  branch_staff_franchise = 'branch_staff_franchise',
}

@Injectable({
  providedIn: 'root',
})
export class UsersService {

  constructor(
    protected api: CoreApiClientService) {
  }

  /**
   * Request for change password.
   * [Authorize] type: http
   */
  public usersChangePasswordPut$(body: ChangePasswordRequestDto): Observable<string> {
    return this.api.put(`${apiBaseUrl()}/users/change-password`, body, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public usersDropdownGet$(page?: number, limit?: number, name?: string, username?: string, userGroup?: string, branchId?: string, roleId?: string, isActive?: boolean, sort?: string): Observable<Array<UserDropdownResponseDto>> {
    return this.api.get(`${apiBaseUrl()}/users/dropdown`, { page, limit, name, username, userGroup, branchId, roleId, isActive, sort });
  }
  /**
   * [Authorize] type: http
   */
  public usersGet$(page?: number, limit?: number, name?: string, username?: string, userGroup?: string, branchId?: string, roleId?: string, isActive?: boolean, sort?: string): Observable<UserPaginationResponseDto> {
    return this.api.get(`${apiBaseUrl()}/users`, { page, limit, name, username, userGroup, branchId, roleId, isActive, sort });
  }
  /**
   * [Authorize] type: http
   */
  public usersIdDelete$(id: string): Observable<string> {
    return this.api.delete(`${apiBaseUrl()}/users/${encodeURIComponent(String(id))}`, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public usersIdGet$(id: string): Observable<UserResponseDto> {
    return this.api.get(`${apiBaseUrl()}/users/${encodeURIComponent(String(id))}`, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public usersIdPut$(id: string, body: UserRequestDto): Observable<UserResponseDto> {
    return this.api.put(`${apiBaseUrl()}/users/${encodeURIComponent(String(id))}`, body, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public usersIdSetPasswordPost$(id: string): Observable<string> {
    return this.api.post(`${apiBaseUrl()}/users/${encodeURIComponent(String(id))}/set-password`, undefined, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public usersIdUpdateIsActivePatch$(id: string): Observable<string> {
    return this.api.patch(`${apiBaseUrl()}/users/${encodeURIComponent(String(id))}/update-is-active`, undefined, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public usersPost$(body: UserRequestDto): Observable<UserResponseDto> {
    return this.api.post(`${apiBaseUrl()}/users`, body, undefined);
  }
}
